import { FC, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { getToken } from "@/localStorage/utils";
import { pages } from "@/routes/constants";

const ProtectedRoute: FC<{
  children: ReactNode;
  isAuthRoute?: boolean;
}> = ({ children, isAuthRoute }) => {
  const isAuthUser = getToken();

  if (isAuthUser && isAuthRoute) {
    return <Navigate to={`/app/${pages.securityAwareness}`} replace />;
  }

  if (!isAuthUser && !isAuthRoute) {
    return <Navigate to={`/auth/${pages.login}`} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
